import { sendRequest } from "../sendRequest";

export const validateOTP = ({ otp, op }) => {
  return sendRequest("post", `/admin/custom-login/token`, {
    otp: String(otp),
    op: String(op),
    userType: "influencer",
  }).then((res) => res.data);
};
